import { NodeModel } from "@minoru/react-dnd-treeview"
import { UnifiedGroupTreeNode } from "../../model"
import { IGroup } from "@/shared/api/groups"

export const toUnifiedGroupTreeNode = (groups: IGroup[]) => {
    const result: NodeModel<UnifiedGroupTreeNode>[] = []
    groups.forEach((group, index) => {
        if (group.users) {
            result.push(...group.users.map((user) => ({
                id: user.id,
                parent: group.id,
                text: user.username,
                droppable: true,
                data: {
                    id: user.id,
                    parent: group.id,
                    username: user.username,
                    name: user.name ?? null,
                    email: user.email ?? null,
                    phone: user.phone ?? null,
                    type: "user" as any
                }
            })))
        }
        result.push({
            id: group.id,
            parent: group.parent_id ?? index,
            text: group.name,
            droppable: true,
            data: {
                id: group.id,
                parent: group.parent_id,
                name: group.name,
                type: "group" as any
            }
        })
    })
    return result.sort((a) => a.data.type === 'group' ? -1 : 1)
}